import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as Styles from './RebootHistoryModal.styles';
import { useSelector } from 'react-redux';

const RebootHistoryModal = ({
  onClose,
  onGoBack,
}) => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: locale } = productDetailsLocale;
  const rebootHistoryLocale = locale && locale.myPlan && locale.myPlan.rebootHistory;

  const vpsOci = useSelector(state => state.vpsOci);
  const history = useSelector(state => state.productDetail.history);

  const listHistoryTimes = history.map((item) => {
    const { id, date } = item;
    return item && item.time && item.time.map(time => ({ id, date, time }));
  });

  return (
    <Modal onClose={onClose} title={rebootHistoryLocale.title} maxWidth={500} testId="reboot-history-modal">
      <Styles.Container>
        <Styles.Message>{rebootHistoryLocale.message(vpsOci.data.productName)}</Styles.Message>
        <Styles.RebootInfo>
          {listHistoryTimes.flat().map(item => (
            <Styles.InfoRow key={`${item.id}-${item.time}`} data-testid="reboot-history-modal-info-row">
              <Styles.Info>
                <Styles.InfoName>{rebootHistoryLocale.date}</Styles.InfoName>
                <Styles.InfoValue>{item.date}</Styles.InfoValue>
              </Styles.Info>
              <Styles.Info>
                <Styles.InfoName>{rebootHistoryLocale.time}</Styles.InfoName>
                <Styles.InfoValue>{item.time}</Styles.InfoValue>
              </Styles.Info>
            </Styles.InfoRow>
          ))}
        </Styles.RebootInfo>
        <Styles.Actions>
          <Button
            label={rebootHistoryLocale.goBack}
            variant="tertiary"
            size="medium2"
            onClick={onGoBack}
            width="fit-content"
            testId="reboot-history-modal-close-button"
          />
        </Styles.Actions>
      </Styles.Container>
    </Modal>
  );
};

export default RebootHistoryModal;
